import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Environment, EnvConfig } from '@doc/core';
import { ApiUrls } from '../backoffice-urls';

@Injectable({
  providedIn: 'root'
})
export class ApplicationManagementService {
  private apiUrl: string;

  constructor(
    @Inject(EnvConfig) private config: Environment,
    private http: HttpClient
  ) {
    this.apiUrl = this.config.apiUrl;
  }


  getAllApplicationList(body:any) {
    const link = this.apiUrl + ApiUrls.getAllApplication;
    return this.http.post<any>(link,body);
  }

  updateApplicationStatus(body:any){
    const link = this.apiUrl + ApiUrls.updateApplicationStatus;
    return this.http.post<any>(link,body);
  }
}
